"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Comment = exports.ETodoState = exports.Email = void 0;
const model_core_1 = require("@nxt/model-core");
const College_1 = require("./College");
const index_1 = require("../index");
class Email extends model_core_1.Base {
    msgId = '';
    root = false;
    io = null; // Inbound or Outbound.
    threadId = '';
    recipients = [];
    subject = '';
    snippet = '';
    body = '';
    html = '';
    opts = {};
    replyTo = '';
    results_sent = 0;
    results_views = 0;
    results_card = 0;
    results_pviews = 0;
    results_plays = 0;
    team = null;
    cRef = null;
    eRef = null;
    from = null;
    cc = [];
    shortUrl = '';
    counts = { comments: 0, emails: 0 };
    constructor(data, olMap) {
        super('emails', 32);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, Email);
    }
    sharePath() {
        if (this._docRef?.path) {
            let user_id = (this._docRef.parent.parent.parent?.parent?.parent.id === 'users') ? this._docRef.parent.parent.parent.parent.id : this._docRef.parent.parent.id;
            let path = this._docRef.path.replace(`users/${user_id}/emails/`, '');
            return `/public/e/${user_id}/${encodeURIComponent(path)}`;
        }
    }
    emptyImgPath() {
        if (this._docRef?.path) {
            let user_id = this._docRef.parent.parent.id;
            let path = this._docRef.path.replace(`users/${user_id}/emails/`, '').replace(/\//g, '~');
            return `/api/profile/${user_id}/${path}/empty.png`;
        }
    }
    get isDraft() {
        return (!this.results_sent && this.io === 'o');
    }
    toJSON() {
        this.root = (this.msgId === this.threadId);
        return super.toJSON();
    }
    async save(parent, setDoc) {
        this.counts.emails = this.counts.emails || 1;
        return super.save(parent, setDoc);
    }
}
exports.Email = Email;
var ETodoState;
(function (ETodoState) {
    ETodoState[ETodoState["NONE"] = null] = "NONE";
    ETodoState["TODO"] = "u";
    ETodoState["DONE"] = "d";
})(ETodoState || (exports.ETodoState = ETodoState = {}));
class Comment extends model_core_1.Base {
    creator = null;
    ref = null;
    message = '';
    object = null;
    cRef = null;
    eRef = null;
    email = null;
    reactions = {};
    todo = ETodoState.NONE;
    constructor(data, olMap) {
        super('comments', 14);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, Email);
    }
    async loadAll(opts, stack, p) {
        opts = opts || {};
        opts.olm = opts.olm || index_1.olm;
        await super.loadAll(opts, stack, p);
        if (this.ref) {
            if (opts?.getDoc) {
                this.object = (0, model_core_1.loadObject)(await opts.getDoc(this.ref), opts);
                await this.object.loadAll(opts);
                if (this.object instanceof College_1.CollegeRef) {
                    this.cRef = this.object;
                }
                else if (this.object instanceof index_1.RcrtEventRef) {
                    this.eRef = this.object;
                }
                else if (this.object instanceof Email) {
                    this.email = this.object;
                    this.cRef = this.email.cRef;
                    this.eRef = this.email.eRef;
                }
            }
            else if (this.ref?.get) {
                this.object = (0, model_core_1.loadObject)(await this.ref.get(), opts);
                await this.object.loadAll(opts);
                if (this.object instanceof College_1.CollegeRef) {
                    this.cRef = this.object;
                }
                else if (this.object instanceof index_1.RcrtEventRef) {
                    this.eRef = this.object;
                }
                else if (this.object instanceof Email) {
                    this.email = this.object;
                    this.cRef = this.email.cRef;
                    this.eRef = this.email.eRef;
                }
            }
        }
    }
    react(react) {
        // If the user already replied, remove it;
        Object.keys(this.reactions || {}).forEach(k => {
            if (this.reactions[k] && this.reactions[k].length) {
                let n = this.reactions[k].findIndex(i => i.id === react.u.id);
                if (n > -1) {
                    this.reactions[k].splice(n, 1);
                }
            }
        });
        this.reactions[react.r] = this.reactions[react.r] || [];
        this.reactions[react.r].push({ name: react.u.name, id: react.u.id });
    }
    toJSON() {
        let r = super.toJSON();
        if (!this.ref) {
            throw `Cannot save Comment without a ref!`;
        }
        if (!this.creator) {
            throw `Cannot save Comment without a creator!`;
        }
        if (!this.message) {
            throw `Cannot save Comment without a message!`;
        }
        this.reactions = Object.keys(this.reactions || {}).reduce((map, k) => {
            if (this.reactions[k] && this.reactions[k].length) {
                map[k] = this.reactions[k].map(i => {
                    return { name: i.name, id: i.id };
                });
            }
            return map;
        }, {});
        delete this.object;
        return r;
    }
}
exports.Comment = Comment;
index_1.olm.emails = (ref, map) => {
    return new Email(ref, map);
};
index_1.olm.comments = (ref, map) => {
    return new Comment(ref, map);
};
